// extracted by mini-css-extract-plugin
export default {"screenContent":"WelcomeScreenOne_screenContent__47lA2","heading":"WelcomeScreenOne_heading__QEUnF","body":"WelcomeScreenOne_body__sRLvb"};